import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getRouteLink } from "../../utils/general";
import { PAGES } from "../../constants/pages";
import { useHistory } from "react-router-dom";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function CustomizedMenu(props: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderedOptions = props.options.map((el: any, index: number) => (
    <div
      style={{
        fontFamily: "Sofia Pro",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "22px",
        display: "flex",
        zIndex: "10",
        alignItems: "center",
        marginLeft: "6px",
        marginRight: "6px",
        marginBottom: "4px",
      }}
      key={el + index}
    >
      <MenuItem
        key={index}
        sx={{ width: "100%" }}
        onClick={() => {
          if (el.page !== "#") {
            history.push(`${getRouteLink(el.page)}`);
          }
          handleClose();
        }}
        disableRipple
        divider={el.hasDivider}
      >
        {el.text}
      </MenuItem>
      <div style={{ display: "flex", gap: "10px" }}>
        {el.hasEditButton && (
          <Button
            style={{
              color: "white",
              height: "28px",
              background: "#161728",
              borderRadius: "10px",
            }}
            onClick={() => props.onEditClick(el.id)}
          >
            Edit
          </Button>
        )}{" "}
        {el.hasEditButton && (
          <Button
            style={{
              color: "#70707A",
              width: "fit-content",
              border: "2px solid #97989E",
              height: "28px",
              background: "white",
              borderRadius: "10px",
            }}
            onClick={() => {
              props.onDeleteClick(el.id);
              handleClose();
            }}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  ));

  return (
    <>
      <Button
        className="font-bold text-white"
        style={{
          borderRadius: "8px",
          borderColor: "white",
          color: "white",
          fontWeight: "600",
          height: "40px",
          padding: "0 16px",
          borderWidth: "2px",
          borderStyle: "solid",
          textTransform: "none",
        }}
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="outlined"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {props.buttonText}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {renderedOptions}
      </StyledMenu>
    </>
  );
}
